import { TimelineLite } from 'gsap/all';
import { Power2 } from 'gsap/gsap-core';
import React, { useEffect } from 'react'
import "../css/Create.css"

function Create() {

    useEffect(() => {
        const tl = new TimelineLite({ paused: true })
        tl.from('.code__gen', 1.5, {
            x: 200,
            ease: Power2.easeOut
        }).from('.idea__gen', 1.5, {
            x: -200,
            ease: Power2.easeOut
        }, '-=1.5')

        tl.play()
    }, [])
    document.addEventListener('DOMContentLoaded', function () {
        let wrapper = document.getElementById('wrapper');
        let topLayer = wrapper.querySelector('.top');
        let handle = wrapper.querySelector('.handle');
        let skew = 0;
        let delta = 0;

        if (wrapper.className.indexOf('skewed') != -1) {
            skew = 1000;
        }

        wrapper.addEventListener('mousemove', function (e) {
            delta = (e.clientX - window.innerWidth / 2) * 0.5;

            handle.style.left = e.clientX + delta + 'px';

            topLayer.style.width = e.clientX + skew + delta + 'px';
        });
    });
    return (
        <div>
            <section id="wrapper" class="skewed">
                <div class="layer bottom">
                    <div class="content-wrap code__gen">
                        <div class="content-body">
                            <h1>Look Sharp</h1>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quisquam temporibus dolore vero reiciendis atque debitis. Sequi at consequatur deserunt?</p>
                        </div>
                        <img src="http://www.traversymedia.com/downloads/assets/image1.png" alt="" />
                    </div>
                </div>

                <div className="layer top">
                    <div class="content-wrap idea__gen">
                        <div class="content-body">
                            <h1>Stay Cool</h1>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quisquam temporibus dolore vero reiciendis atque debitis. Sequi at consequatur deserunt?</p>
                        </div>
                        <img src="http://www.traversymedia.com/downloads/assets/image2.png" alt="" />
                    </div>
                </div>

                <div class="handle"></div>
            </section>
        </div>
    )
}

export default Create
